import React from "react";
import { InputDate, InputGroup } from "~/components/form";
import { MdDelete } from "react-icons/md";
import { IconButton } from "~/components/crud/styles";
import { ContentContainer, ImageContainer } from "~/views/persons/styles";
import FileImageCrop from "~/components/form/file-image-crop";
import ImageAuth from "~/components/image";
import _ from "lodash";

export const TabCovid = ({
  errors,
  fromGroup,
  isPress,
  touched,
  values,
  onListRoles,
  previewMode,
  setFieldValue,
}) => {
  return (
    <ContentContainer>
      <InputGroup
        type="text"
        name="covidResult"
        label="Resultado do exame"
        maxLength={50}
        disabled={previewMode}
        hasError={_.get(errors, "covidResult") && _.get(touched, "covidResult")}
      />

      <InputDate
        name="covidDate"
        label="Data do exame"
        disabled={previewMode}
        hasError={_.get(errors, "covidDate") && _.get(touched, "covidDate")}
      />

      <ImageContainer>
        <h4>
          <span>Certificado de vacinação</span>
          {values.vaccinationCertificate && (
            <IconButton
              title="Limpar imagem"
              onClick={() => setFieldValue("vaccinationCertificate", null)}
            >
              <MdDelete />
            </IconButton>
          )}
        </h4>
        {values.vaccinationCertificate ? (
          <ImageAuth
            withoutLoading={true}
            src={values.vaccinationCertificate ? `/persons/photo/${values.id}/vaccinationCertificate` : ""}
          />
        ) : (
          <FileImageCrop
            label="Clique aqui para selecionar a imagem"
            name="newVaccinationCertificate"
            asBase64={true}
            height={"200px"}
          />
        )}
      </ImageContainer>
      
      <br />

      <ImageContainer>
        <h4>
          <span>Exame PCR</span>
          {values.checkUpPCR && (
            <IconButton
              title="Limpar imagem"
              onClick={() => setFieldValue("checkUpPCR", null)}
            >
              <MdDelete />
            </IconButton>
          )}
        </h4>
        {values.checkUpPCR ? (
          <ImageAuth
            withoutLoading={true}
            src={values.checkUpPCR ? `/persons/photo/${values.id}/checkUpPCR` : ""}
          />
        ) : (
          <FileImageCrop
            label="Clique aqui para selecionar a imagem"
            name="newCheckUpPCR"
            asBase64={true}
            height={"200px"}
          />
        )}
      </ImageContainer>
    </ContentContainer>
  );
};
